const grid = document.querySelector('#accompaniement-grid');

const msnry = new Masonry(grid, {
  itemSelector: '.accompaniement-list__item',
  columnWidth: '.accompaniement-list__item',
  gutter: 30,
  percentPosition: true,
});

const accompaniementSwiper = new Swiper('#accompaniement-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    576: {
      autoHeight: false,
      slidesPerView: 'auto',
      spaceBetween: 60,
      centeredSlides: true,
    },
  },
});
